<label>{{model.tit}}</label>
<app-treevi class="treev" [model]="model.trvis"></app-treevi>